import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import {
  GetReportReq,
  GetReportResp,
  GetCheckListReq,
  GetCheckListResp,
  DefectTypeReq,
  DefectItem,
  SendDefectReq,
  ConstructPlanReport,
  SetDefectReq,
  VerifyDefectReq,
  ResendReportReq,
  SendEditReportToQCReq,
  CommonResp,
} from './types'

export const getReportAction = createAsyncAction(
  'report/constructPlan/FETCH_REPORT_REQUEST',
  'report/constructPlan/FETCH_REPORT_SUCCESS',
  'report/constructPlan/FETCH_REPORT_FAILURE'
)<GetReportReq, GetReportResp, any>()

export const getCheckListAction = createAsyncAction(
  'report/constructPlan/GET_CHECKLIST_QC_REQ',
  'report/constructPlan/GET_CHECKLIST_QC_RESP',
  'report/constructPlan/GET_CHECKLIST_QC_FAIL'
)<GetCheckListReq, GetCheckListResp, any>()

export const resetDefect = createStandardAction(
  'report/constructPlan/RESET_DEFECT_ACTION'
)<void>()

export const updateDefect = createStandardAction(
  'report/constructPlan/UPDATE_DEFECT_ACTION'
)<DefectItem>()

export const createDefectAction = createAsyncAction(
  'report/constructPlan/CREATE_DEFECT_REQ',
  'report/constructPlan/CREATE_DEFECT_RESP',
  'report/constructPlan/CREATE_DEFECT_FAIL'
)<DefectTypeReq, CommonResp, any>()

export const updateDefectAction = createAsyncAction(
  'report/constructPlan/UPDATE_DEFECT_REQ',
  'report/constructPlan/UPDATE_DEFECT_RESP',
  'report/constructPlan/UPDATE_DEFECT_FAIL'
)<DefectTypeReq, CommonResp, any>()

export const setDefectAction = createAsyncAction(
  'report/constructPlan/SET_DEFECT_REQ',
  'report/constructPlan/SET_DEFECT_RESP',
  'report/constructPlan/SET_DEFECT_FAIL'
)<SetDefectReq, CommonResp, any>()

export const verifyDefectAction = createAsyncAction(
  'report/constructPlan/VERIFY_DEFECT_REQ',
  'report/constructPlan/VERIFY_DEFECT_RESP',
  'report/constructPlan/VERIFY_DEFECT_FAIL'
)<VerifyDefectReq, CommonResp, any>()

export const resendReportAction = createAsyncAction(
  'report/constructPlan/RESEND_REPORT_REQ',
  'report/constructPlan/RESEND_REPORT_RESP',
  'report/constructPlan/RESEND_REPORT_FAIL'
)<ResendReportReq, CommonResp, any>()

export const sendEditReportAction = createAsyncAction(
  'report/constructPlan/SEND_EDIT_REPORT_REQ',
  'report/constructPlan/SEND_EDIT_REPORT_RESP',
  'report/constructPlan/SEND_EDIT_REPORT_FAIL'
)<SendEditReportToQCReq, CommonResp, any>()

export const submitDefectReq = createStandardAction(
  'report/constructPlan/SUBMIT_REQUEST'
)<SendDefectReq>()

export const setHowToFixReq = createStandardAction(
  'report/constructPlan/SUBMIT_HOWTOFIX_REQUEST'
)<SendDefectReq>()

export const updateReport = createStandardAction(
  'report/constructPlan/UPDATE_REPORT_ACTION'
)<ConstructPlanReport>()

export const resetEvent = createStandardAction(
  'report/constructPlan/RESET_EVENT_ACTION'
)<void>()
